(function () {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var CMW_STOREFRONT_ENDPOINT = 'https://container-modification-world.myshopify.com/api/2024-10/graphql.json';
  var CMW_STOREFRONT_TOKEN = '17ccdf44c63a450934e78389de2cb5d3';
  var cmwProductCache = {};
  var tcgProductCache = {};

  function canon(value) {
    return String(value || '').trim().toLowerCase().replace(/[\u2122\u00ae]/g, '').replace(/\s+/g, ' ');
  }

  function cleanProductHandle(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    try {
      var url = raw.indexOf('http') === 0 ? new URL(raw) : new URL(raw, 'https://containermodificationworld.com');
      var segments = url.pathname.split('/').map(function (part) {
        return part.trim();
      }).filter(Boolean);
      var last = segments[segments.length - 1] || '';
      return ['products', 'collections', 'search'].indexOf(last) !== -1 ? '' : last;
    } catch (error) {
      return raw.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean).pop() || '';
    }
  }

  function splitSkus(value) {
    return String(value || '')
      .split('|')
      .map(function (sku) { return canon(sku); })
      .filter(Boolean);
  }

  function moneyFromVariant(variant, fallbackPrice) {
    var price = variant && variant.price;
    var amount = price && price.amount;

    if (amount !== undefined && amount !== null && amount !== '') {
      var number = Number(amount);
      if (Number.isFinite(number)) {
        return '$' + number.toFixed(2);
      }
    }

    return fallbackPrice || '';
  }

  function variantLabel(variant, product) {
    if (!variant) return '';
    if (variant.title && variant.title === 'Default Title') return '';

    var options = Array.isArray(variant.selectedOptions)
      ? variant.selectedOptions.map(function (option) { return option && option.value; }).filter(Boolean)
      : [];

    if (options.length) return options.join(' / ');
    if (variant.title) return variant.title;
    return product && product.title ? product.title : 'Standard option';
  }

  function storefrontQuery(query, variables) {
    return fetch(CMW_STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CMW_STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('CMW Storefront request failed: ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          throw new Error(payload.errors.map(function (error) { return error.message; }).join('; '));
        }
        return payload.data || {};
      });
  }

  function normalizeCmwProduct(node) {
    if (!node) return null;
    return {
      id: node.id,
      handle: node.handle,
      title: node.title,
      variants: ((node.variants && node.variants.edges) || []).map(function (edge) {
        return edge.node;
      }).filter(Boolean)
    };
  }

  function cmwProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return storefrontQuery(
      'query TcgCatalogueCmwProductByHandle($handle: String!) { productByHandle(handle: $handle) { id handle title variants(first: 80) { edges { node { id title sku availableForSale price { amount currencyCode } selectedOptions { name value } } } } } }',
      { handle: handle }
    ).then(function (data) {
      return normalizeCmwProduct(data.productByHandle);
    }).catch(function () {
      return null;
    });
  }

  function searchScore(node, expectedHandle, expectedTitle) {
    if (!node) return 0;

    var nodeHandle = canon(node.handle);
    var nodeTitle = canon(node.title);
    var handle = canon(expectedHandle);
    var title = canon(expectedTitle);

    if (handle && nodeHandle === handle) return 100;
    if (title && nodeTitle === title) return 95;
    if (title && (nodeTitle.indexOf(title) !== -1 || title.indexOf(nodeTitle) !== -1)) return 85;

    var terms = title.split(/[^a-z0-9]+/).filter(function (term) {
      return term.length > 2 && ['for', 'and', 'the', 'with', 'shipping', 'containers', 'container', 'cans', 'sea'].indexOf(term) === -1;
    });

    return terms.reduce(function (score, term) {
      return score + (nodeTitle.indexOf(term) !== -1 || nodeHandle.indexOf(term) !== -1 ? 8 : 0);
    }, 0);
  }

  function cmwProductSearch(searchTerm, expectedHandle, expectedTitle) {
    var queryText = String(searchTerm || '').trim();
    if (!queryText) return Promise.resolve(null);

    return storefrontQuery(
      'query TcgCatalogueCmwProductSearch($query: String!) { products(first: 10, query: $query) { edges { node { id handle title variants(first: 80) { edges { node { id title sku availableForSale price { amount currencyCode } selectedOptions { name value } } } } } } } }',
      { query: queryText }
    ).then(function (data) {
      var products = ((data.products && data.products.edges) || []).map(function (edge) {
        return edge.node;
      }).filter(Boolean);
      var best = products.map(function (node) {
        return { node: node, score: searchScore(node, expectedHandle, expectedTitle) };
      }).sort(function (a, b) {
        return b.score - a.score;
      })[0];

      return best && best.score > 0 ? normalizeCmwProduct(best.node) : null;
    }).catch(function () {
      return null;
    });
  }

  function findCmwProduct(product) {
    var cmwHandle = cleanProductHandle(product.cmwUrl);
    var cacheKey = [cmwHandle, product.handle, product.title].join('|');
    if (cmwProductCache[cacheKey]) return cmwProductCache[cacheKey];

    var searchTerms = [
      product.title,
      cmwHandle ? cmwHandle.replace(/-/g, ' ') : '',
      product.handle ? product.handle.replace(/-/g, ' ') : '',
      String(product.title || '').replace(/for shipping containers\/sea cans/ig, '').replace(/for shipping containers/ig, '').trim()
    ].filter(Boolean);

    cmwProductCache[cacheKey] = cmwProductByHandle(cmwHandle)
      .then(function (found) { return found || cmwProductByHandle(product.handle); })
      .then(function (found) {
        if (found) return found;

        return searchTerms.reduce(function (promise, term) {
          return promise.then(function (result) {
            return result || cmwProductSearch(term, cmwHandle || product.handle, product.title);
          });
        }, Promise.resolve(null));
      })
      .then(function (found) {
        if (!found) throw new Error('Missing CMW product mapping.');
        return found;
      });

    return cmwProductCache[cacheKey];
  }

  function remoteVariantCartId(variant) {
    var id = String((variant && variant.id) || '').trim();
    if (!id) return '';
    if (id.indexOf('gid://shopify/ProductVariant/') === 0) return id;

    var numericId = id.match(/ProductVariant\/(\d+)/);
    if (numericId) return 'gid://shopify/ProductVariant/' + numericId[1];
    if (/^\d+$/.test(id)) return 'gid://shopify/ProductVariant/' + id;
    return '';
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2122\u00ae]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function handleFromProductUrl(product) {
    if (!product || !product.url) return '';

    try {
      var url = new URL(product.url, window.location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      return parts[0] === 'products' ? parts[1] || '' : '';
    } catch (error) {
      var parts = String(product.url || '').split('?')[0].split('/').filter(Boolean);
      return parts[0] === 'products' ? parts[1] || '' : parts.pop() || '';
    }
  }

  function tcgProductJsonUrls(product) {
    var handles = [];
    var currentHandle = handleFromProductUrl(product);
    var titleHandle = handleize(product && product.title);

    [currentHandle, titleHandle].forEach(function (handle) {
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
      if (handle && handle.indexOf('fjm-') === 0) {
        var cmwHandle = handle.replace(/^fjm-/, 'cmw-');
        if (handles.indexOf(cmwHandle) === -1) handles.push(cmwHandle);
      }
    });

    return handles.map(function (handle) {
      return '/products/' + handle + '.js';
    });
  }

  function fetchFirstProductJson(urls) {
    if (!urls.length) return Promise.resolve(null);
    var url = urls.shift();

    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('TCG product JSON failed: ' + response.status);
        return response.json();
      })
      .catch(function () {
        return fetchFirstProductJson(urls);
      });
  }

  function fetchTcgProduct(product) {
    var cacheKey = [product && product.url, product && product.title].join('|');
    if (!cacheKey.trim()) return Promise.resolve(null);
    if (tcgProductCache[cacheKey]) return tcgProductCache[cacheKey];

    tcgProductCache[cacheKey] = fetchFirstProductJson(tcgProductJsonUrls(product));
    return tcgProductCache[cacheKey];
  }

  function matchTcgVariant(tcgProduct, cmwVariant) {
    var variants = tcgProduct && Array.isArray(tcgProduct.variants) ? tcgProduct.variants : [];
    if (!variants.length || !cmwVariant) return null;

    var cmwSku = canon(cmwVariant.sku);
    if (cmwSku) {
      var skuMatch = variants.find(function (variant) {
        return canon(variant.sku) === cmwSku;
      });
      if (skuMatch) return skuMatch;
    }

    var cmwTitle = canon(cmwVariant.title);
    if (cmwTitle && cmwTitle !== 'default title') {
      var titleMatch = variants.find(function (variant) {
        return canon(variant.title) === cmwTitle;
      });
      if (titleMatch) return titleMatch;
    }

    return variants.length === 1 ? variants[0] : null;
  }

  function productDetailUrl(product, variant, tcgProduct) {
    var base = tcgProduct && tcgProduct.handle ? '/products/' + tcgProduct.handle : product && product.url ? product.url : '#';
    if (!variant || !variant.id) return base;

    try {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('variant', variant.id);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variant.id);
    }
  }

  function pickCmwVariant(remoteProduct, product) {
    var variants = (remoteProduct && remoteProduct.variants || []).filter(function (variant) {
      return variant.availableForSale !== false;
    });
    if (!variants.length) return null;

    var skus = splitSkus(product.sku);
    if (skus.length) {
      var skuMatch = variants.find(function (variant) {
        return skus.indexOf(canon(variant.sku)) !== -1;
      });
      if (skuMatch) return skuMatch;
    }

    var defaultVariant = variants.find(function (variant) {
      return variant.title === 'Default Title';
    });
    return defaultVariant || variants[0];
  }

  function setAddButtonState(button, label, disabled) {
    button.textContent = label;
    button.disabled = Boolean(disabled);
    button.setAttribute('aria-busy', disabled ? 'true' : 'false');
  }

  function ensureVariantChooser(root) {
    var existing = document.querySelector('[data-tcg-catalogue-variant-chooser]');
    if (existing) return existing;

    var chooser = document.createElement('div');
    chooser.className = 'tcg-hub-catalogue__chooser';
    chooser.hidden = true;
    chooser.dataset.tcgCatalogueVariantChooser = 'true';
    chooser.innerHTML = [
      '<div class="tcg-hub-catalogue__chooser-scrim" data-tcg-catalogue-chooser-close></div>',
      '<div class="tcg-hub-catalogue__chooser-dialog" role="dialog" aria-modal="true" aria-labelledby="tcg-hub-catalogue-chooser-title">',
      '  <div class="tcg-hub-catalogue__chooser-head">',
      '    <span class="tcg-hub-card__meta" data-tcg-catalogue-chooser-eyebrow>Choose option</span>',
      '    <button type="button" data-tcg-catalogue-chooser-close aria-label="Close option selector">Close</button>',
      '  </div>',
      '  <h3 id="tcg-hub-catalogue-chooser-title"></h3>',
      '  <p class="tcg-hub-catalogue__chooser-help" data-tcg-catalogue-chooser-help>Pick the option you want to add. For details, open the product page.</p>',
      '  <div class="tcg-hub-catalogue__variant-list" data-tcg-catalogue-variant-list></div>',
      '  <p class="tcg-hub-catalogue__variant-status" hidden data-tcg-catalogue-variant-status></p>',
      '  <div class="tcg-hub-catalogue__quantity" data-tcg-catalogue-quantity-wrap>',
      '    <span class="tcg-hub-catalogue__quantity-label">Quantity</span>',
      '    <div class="tcg-hub-catalogue__quantity-stepper">',
      '      <button type="button" data-tcg-catalogue-qty="-1" aria-label="Decrease quantity">-</button>',
      '      <input type="number" value="1" min="1" max="99" inputmode="numeric" pattern="[0-9]*" data-tcg-catalogue-quantity aria-label="Quantity">',
      '      <button type="button" data-tcg-catalogue-qty="1" aria-label="Increase quantity">+</button>',
      '    </div>',
      '  </div>',
      '  <div class="tcg-hub-catalogue__chooser-actions">',
      '    <a class="tcg-hub-catalogue__chooser-details" href="#">View product details</a>',
      '    <button type="button" class="tcg-hub-catalogue__chooser-add" data-tcg-catalogue-chooser-add disabled>Add to cart</button>',
      '  </div>',
      '</div>'
    ].join('');

    (document.body || root).appendChild(chooser);
    return chooser;
  }

  function chooserQuantity(chooser) {
    var input = chooser && chooser.querySelector('[data-tcg-catalogue-quantity]');
    var value = input ? Number(input.value) : 1;
    var quantity = Math.max(1, Math.min(99, Math.floor(Number.isFinite(value) ? value : 1)));
    if (input && String(quantity) !== input.value) input.value = quantity;
    return quantity;
  }

  function chooserAddLabel(chooser) {
    return 'Add ' + chooserQuantity(chooser) + ' to cart';
  }

  function updateChooserAddButton(chooser, disabled) {
    var add = chooser && chooser.querySelector('[data-tcg-catalogue-chooser-add]');
    if (add) setAddButtonState(add, chooserAddLabel(chooser), Boolean(disabled));
  }

  function closeVariantChooser(chooser) {
    if (!chooser) return;
    chooser.hidden = true;
    document.documentElement.classList.remove('tcg-hub-catalogue--chooser-open');
  }

  function setChooserStatus(chooser, message, isError) {
    var status = chooser.querySelector('[data-tcg-catalogue-variant-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function variantOptionMarkup(variant, product, selected) {
    var id = remoteVariantCartId(variant);
    var label = variantLabel(variant, product);
    var sku = variant && variant.sku ? '<span>' + escapeHtml(variant.sku) + '</span>' : '';
    var price = moneyFromVariant(variant, product.price);
    var labelMarkup = label ? '<strong>' + escapeHtml(label) + '</strong>' : '';

    return [
      '<label class="tcg-hub-catalogue__variant-option' + (selected ? ' is-selected' : '') + '">',
      '  <input type="radio" name="tcg-catalogue-variant" value="' + escapeHtml(id) + '"' + (selected ? ' checked' : '') + '>',
      '  <span>',
      labelMarkup,
      sku,
      '  </span>',
      '  <b>' + escapeHtml(price) + '</b>',
      '</label>'
    ].join('');
  }

  function openVariantChooser(root, product, triggerButton) {
    var chooser = ensureVariantChooser(root);
    var title = chooser.querySelector('#tcg-hub-catalogue-chooser-title');
    var list = chooser.querySelector('[data-tcg-catalogue-variant-list]');
    var add = chooser.querySelector('[data-tcg-catalogue-chooser-add]');
    var details = chooser.querySelector('.tcg-hub-catalogue__chooser-details');
    var quantity = chooser.querySelector('[data-tcg-catalogue-quantity]');
    var eyebrow = chooser.querySelector('[data-tcg-catalogue-chooser-eyebrow]');
    var help = chooser.querySelector('[data-tcg-catalogue-chooser-help]');

    chooser.hidden = false;
    chooser.tcgCatalogueActiveProduct = product;
    chooser.tcgCatalogueTriggerButton = triggerButton;
    document.documentElement.classList.add('tcg-hub-catalogue--chooser-open');
    document.documentElement.classList.toggle('tcg-hub-catalogue--has-preview-bar', Boolean(document.getElementById('PBarNextFrameWrapper')));
    if (title) title.textContent = product.title || 'Choose option';
    if (details) details.href = product.url || '#';
    if (eyebrow) eyebrow.textContent = 'Choose option';
    if (help) help.textContent = 'Pick the option you want to add. For details, open the product page.';
    if (list) list.innerHTML = '<p class="tcg-hub-catalogue__variant-loading">Loading options...</p>';
    if (quantity) quantity.value = 1;
    updateChooserAddButton(chooser, true);
    setChooserStatus(chooser, '', false);

    findCmwProduct(product)
      .then(function (remoteProduct) {
        var variants = (remoteProduct.variants || []).filter(function (variant) {
          return variant.availableForSale !== false && remoteVariantCartId(variant);
        });

        if (!variants.length) throw new Error('No available CMW variants.');

        if (eyebrow) eyebrow.textContent = variants.length > 1 ? 'Choose option' : 'Confirm item';
        if (help) {
          help.textContent = variants.length > 1
            ? 'Pick the option you want to add. For details, open the product page.'
            : 'Confirm the quantity before adding to cart. For details, open the product page.';
        }

        var preferred = pickCmwVariant(remoteProduct, product) || variants[0];
        var preferredId = remoteVariantCartId(preferred);
        list.innerHTML = variants.map(function (variant) {
          return variantOptionMarkup(variant, product, remoteVariantCartId(variant) === preferredId);
        }).join('');

        var tcgProductPromise = fetchTcgProduct(product);

        function selectedCmwVariant() {
          var selected = chooser.querySelector('input[name="tcg-catalogue-variant"]:checked');
          if (!selected) return null;

          return variants.find(function (variant) {
            return remoteVariantCartId(variant) === selected.value;
          }) || null;
        }

        function syncDetailsLink() {
          if (!details) return;

          var cmwVariant = selectedCmwVariant();
          details.href = product.url || '#';

          tcgProductPromise.then(function (tcgProduct) {
            if (chooser.tcgCatalogueActiveProduct !== product) return;
            if (selectedCmwVariant() !== cmwVariant) return;
            details.href = productDetailUrl(product, matchTcgVariant(tcgProduct, cmwVariant), tcgProduct);
          });
        }

        function syncSelection() {
          var selected = chooser.querySelector('input[name="tcg-catalogue-variant"]:checked');
          chooser.querySelectorAll('.tcg-hub-catalogue__variant-option').forEach(function (option) {
            option.classList.toggle('is-selected', option.querySelector('input') === selected);
          });
          updateChooserAddButton(chooser, !selected);
          syncDetailsLink();
        }

        list.querySelectorAll('input[name="tcg-catalogue-variant"]').forEach(function (input) {
          input.addEventListener('change', syncSelection);
        });

        syncSelection();
      })
      .catch(function (error) {
        console.warn('CMW option load failed:', error);
        if (list) list.innerHTML = '';
        setChooserStatus(chooser, 'Options could not be loaded here. Open the product page and we will help complete the order.', true);
      });

    if (add && add.dataset.bound !== 'true') {
      add.dataset.bound = 'true';
      add.addEventListener('click', function () {
        var selected = chooser.querySelector('input[name="tcg-catalogue-variant"]:checked');
        var merchandiseId = selected && selected.value;

        if (!merchandiseId || typeof window.CMW_LIGHT_CART_ADD !== 'function') {
          setChooserStatus(chooser, 'This option could not be added from the hub. Open the product page and we will help complete the order.', true);
          return;
        }

        var quantity = chooserQuantity(chooser);
        setAddButtonState(add, 'Adding...', true);
        setChooserStatus(chooser, 'Adding to cart...', false);

        window.CMW_LIGHT_CART_ADD(merchandiseId, quantity)
          .then(function () {
            if (window.CMW_BB_REFRESH_CART) window.CMW_BB_REFRESH_CART();
            document.dispatchEvent(new CustomEvent('cmw:cart:updated'));
            setAddButtonState(add, 'Added ' + quantity, false);
            setChooserStatus(chooser, 'Added ' + quantity + ' to cart. Checkout is handled by Container Modification World.', false);
            var activeTrigger = chooser.tcgCatalogueTriggerButton;
            if (activeTrigger) {
              setAddButtonState(activeTrigger, 'Added ' + quantity, false);
              window.setTimeout(function () {
                setAddButtonState(activeTrigger, 'Add to cart', false);
              }, 1800);
            }
            closeVariantChooser(chooser);
            if (activeTrigger) activeTrigger.focus({ preventScroll: true });
          })
          .catch(function (error) {
            console.warn('CMW chooser add to cart failed:', error);
            updateChooserAddButton(chooser, false);
            setChooserStatus(chooser, 'This option could not be added. Open the product page and we will help complete the order.', true);
          });
      });
    }

    chooser.querySelectorAll('[data-tcg-catalogue-qty]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var input = chooser.querySelector('[data-tcg-catalogue-quantity]');
        var delta = Number(button.dataset.tcgCatalogueQty || 0);
        var current = chooserQuantity(chooser);
        if (input) input.value = Math.max(1, Math.min(99, current + delta));
        updateChooserAddButton(chooser, !chooser.querySelector('input[name="tcg-catalogue-variant"]:checked'));
      });
    });

    if (quantity && quantity.dataset.bound !== 'true') {
      quantity.dataset.bound = 'true';
      quantity.addEventListener('input', function () {
        var cleaned = String(quantity.value || '').replace(/[^0-9]/g, '').slice(0, 2);
        quantity.value = cleaned || '1';
        updateChooserAddButton(chooser, !chooser.querySelector('input[name="tcg-catalogue-variant"]:checked'));
      });
      quantity.addEventListener('blur', function () {
        chooserQuantity(chooser);
        updateChooserAddButton(chooser, !chooser.querySelector('input[name="tcg-catalogue-variant"]:checked'));
      });
    }

    chooser.querySelectorAll('[data-tcg-catalogue-chooser-close]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        closeVariantChooser(chooser);
        if (chooser.tcgCatalogueTriggerButton) chooser.tcgCatalogueTriggerButton.focus();
      });
    });

    window.setTimeout(function () {
      var close = chooser.querySelector('[data-tcg-catalogue-chooser-close]');
      if (close) close.focus();
    }, 0);
  }

  function productFromAddButton(button) {
    return {
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      price: button.dataset.productPrice || '',
      sku: button.dataset.productSku || '',
      cmwUrl: button.dataset.cmwUrl || '',
      url: button.dataset.productUrl || ''
    };
  }

  function bindAddButtons(root) {
    if (!root || root.dataset.tcgCatalogueAddBound === 'true') return;
    root.dataset.tcgCatalogueAddBound = 'true';

    root.addEventListener('click', function (event) {
      var button = event.target && event.target.closest && event.target.closest('[data-tcg-catalogue-add]');
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      openVariantChooser(root, productFromAddButton(button), button);
    });
  }

  function bindGlobalChooserEvents() {
    if (document.documentElement.dataset.tcgCatalogueGlobalBound === 'true') return;
    document.documentElement.dataset.tcgCatalogueGlobalBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var chooser = document.querySelector('[data-tcg-catalogue-variant-chooser]');
      if (chooser && !chooser.hidden) closeVariantChooser(chooser);
    });
  }

  function initFeaturedCarousel(root) {
    if (!root || root.dataset.tcgFeaturedCarouselReady === 'true') return;
    root.dataset.tcgFeaturedCarouselReady = 'true';

    var track = root.querySelector('[data-tcg-featured-track]');
    var prev = root.querySelector('[data-tcg-featured-prev]');
    var next = root.querySelector('[data-tcg-featured-next]');
    if (!track || !prev || !next) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayTimer = null;
    var paused = false;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function scrollStep() {
      var card = track.querySelector('.tcg-featured-parts__card');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0) || 0;
      return card ? card.getBoundingClientRect().width + gap : Math.max(280, track.clientWidth * 0.75);
    }

    function move(direction, smooth) {
      var max = maxScroll();
      if (max <= 2) return;

      var current = track.scrollLeft;
      var nextLeft = current + (scrollStep() * direction);
      if (direction > 0 && nextLeft >= max - 4) nextLeft = 0;
      if (direction < 0 && nextLeft <= 4) nextLeft = max;

      track.scrollTo({
        left: nextLeft,
        behavior: smooth === false || reducedMotion ? 'auto' : 'smooth'
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (reducedMotion || autoplayTimer || maxScroll() <= 2) return;
      autoplayTimer = window.setInterval(function () {
        if (paused || document.hidden || document.documentElement.classList.contains('tcg-hub-catalogue--chooser-open')) return;
        move(1, true);
      }, 5200);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
      startAutoplay();
    }

    prev.addEventListener('click', function () {
      pause();
      move(-1, true);
      window.setTimeout(resume, 6500);
    });

    next.addEventListener('click', function () {
      pause();
      move(1, true);
      window.setTimeout(resume, 6500);
    });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement)) resume();
      }, 0);
    });
    track.addEventListener('pointerdown', function () {
      pause();
      window.setTimeout(resume, 6500);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pause();
      } else {
        resume();
      }
    });

    startAutoplay();
  }

  function productRow(product) {
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" width="96" height="96" loading="lazy">'
      : '<span aria-hidden="true"></span>';
    var type = product.type ? '<span>' + escapeHtml(product.type) + '</span>' : '';
    var sku = product.sku ? '<span>' + escapeHtml(product.sku) + '</span>' : '';
    var fulfillment = (product.vendor || '').toLowerCase().indexOf('container modification world') !== -1
      ? '<span>CMW fulfilled</span>'
      : '';
    var meta = type + sku + fulfillment;
    return [
      '<article class="tcg-hub-catalogue__item" data-tcg-catalogue-item data-category="' + escapeHtml(product.category) + '" data-search="' + escapeHtml(product.search) + '">',
      '  <a class="tcg-hub-catalogue__main" href="' + escapeHtml(product.url) + '">',
      '    <span class="tcg-hub-catalogue__image">' + image + '</span>',
      '    <span class="tcg-hub-catalogue__copy">',
      '      <span class="tcg-hub-catalogue__title">' + escapeHtml(product.title) + '</span>',
      '      <span class="tcg-hub-catalogue__summary">' + escapeHtml(product.summary) + '</span>',
      meta ? '      <span class="tcg-hub-catalogue__meta">' + meta + '</span>' : '',
      '    </span>',
      '    <span class="tcg-hub-catalogue__price">' + escapeHtml(product.price) + '</span>',
      '  </a>',
      '  <button type="button" class="tcg-hub-catalogue__action" data-tcg-catalogue-add data-product-url="' + escapeHtml(product.url) + '" data-product-handle="' + escapeHtml(product.handle) + '" data-product-title="' + escapeHtml(product.title) + '" data-product-price="' + escapeHtml(product.price) + '" data-product-sku="' + escapeHtml(product.sku) + '" data-cmw-url="' + escapeHtml(product.cmwUrl) + '">Add to cart</button>',
      '</article>',
    ].join('');
  }

  function categoryIcon(slug) {
    var paths = {
      security: '<rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path><path d="M12 14v2"></path>',
      ventilation: '<rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M7 9h10M7 12h10M7 15h10"></path>',
      'framing-systems': '<path d="M5 4h14M8 4v16M16 4v16M5 20h14"></path><path d="M8 9h8M8 15h8"></path>',
      'windows-door-kits': '<rect x="3" y="4" width="18" height="16" rx="1"></rect><path d="M12 4v16M3 12h9"></path><circle cx="17.5" cy="12" r="0.75" fill="currentColor" stroke="none"></circle>',
      'electrical-solar': '<path d="M13 2 6 13h5l-1 9 8-12h-5V2Z"></path>',
      'storage-shelving-racking': '<path d="M5 3v18M19 3v18M5 7h14M5 13h14M5 19h14"></path><path d="M8 9h3v4H8zM14 14h3v5h-3z"></path>',
      'access-ramps-stairs': '<path d="M3 20h5v-4h4v-4h4V8h5"></path><path d="m4 14 10-10h7"></path>',
      'hardware-components': '<path d="m14.7 6.3 3-3a4 4 0 0 1-5 5L6 15l3 3 6.7-6.7a4 4 0 0 1 5-5l-3 3"></path><path d="m4.5 16.5 3 3"></path>'
    };
    var icon = paths[slug] || '<path d="M4 7h16v12H4zM8 7V4h8v3M4 12h16"></path>';

    return '<span class="tcg-hub-catalogue__category-icon" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false">' + icon + '</svg></span>';
  }

  function render(root, data) {
    if (!root || root.dataset.tcgCatalogueReady === 'true') return;
    root.dataset.tcgCatalogueReady = 'true';

    var filters = root.querySelector('[data-tcg-catalogue-filters]');
    var groups = root.querySelector('[data-tcg-catalogue-groups]');
    var search = root.querySelector('[data-tcg-catalogue-search]');
    var clear = root.querySelector('[data-tcg-catalogue-clear]');
    var count = root.querySelector('[data-tcg-catalogue-count]');
    var empty = root.querySelector('[data-tcg-catalogue-empty]');
    var expand = root.querySelector('[data-tcg-catalogue-expand]');
    var collapse = root.querySelector('[data-tcg-catalogue-collapse]');
    if (!filters || !groups || !search || !clear || !count || !empty) return;

    var activeCategory = 'all';
    var categories = data.categories.filter(function (category) {
      return category.count > 0;
    });
    var products = data.products || [];
    var openCategories = {};
    var defaultOpenCategory = categories[0] ? categories[0].slug : '';
    categories.forEach(function (category) {
      openCategories[category.slug] = category.slug === defaultOpenCategory;
    });

    filters.innerHTML = [
      '<button type="button" class="tcg-hub-catalogue__filter is-active" data-category="all" aria-pressed="true">All <span>' + products.length + '</span></button>',
    ].concat(categories.map(function (category) {
      return '<button type="button" class="tcg-hub-catalogue__filter" data-category="' + escapeHtml(category.slug) + '" aria-pressed="false">' + escapeHtml(category.label) + ' <span>' + category.count + '</span></button>';
    })).join('');

    groups.innerHTML = categories.map(function (category) {
      var categoryProducts = products.filter(function (product) {
        return product.category === category.slug;
      });
      var listId = 'parts-' + escapeHtml(category.slug) + '-list';
      return [
        '<section class="tcg-hub-catalogue__group" data-tcg-catalogue-group data-category="' + escapeHtml(category.slug) + '" id="parts-' + escapeHtml(category.slug) + '">',
        '  <button type="button" class="tcg-hub-catalogue__group-toggle" data-tcg-catalogue-toggle data-category="' + escapeHtml(category.slug) + '" aria-expanded="false" aria-controls="' + listId + '">',
        '    ' + categoryIcon(category.slug),
        '    <span class="tcg-hub-catalogue__group-title">',
        '      <span class="tcg-hub-card__meta">' + escapeHtml(category.count + ' products') + '</span>',
        '      <span>' + escapeHtml(category.label) + '</span>',
        '    </span>',
        '    <span class="tcg-hub-catalogue__group-short">' + escapeHtml(category.short) + '</span>',
        '    <span class="tcg-hub-catalogue__group-icon" aria-hidden="true">+</span>',
        '  </button>',
        '  <div class="tcg-hub-catalogue__list" id="' + listId + '" hidden>',
        categoryProducts.map(productRow).join(''),
        '  </div>',
        '</section>',
      ].join('');
    }).join('');

    function setGroupOpen(group, open) {
      var category = group.dataset.category;
      var toggle = group.querySelector('[data-tcg-catalogue-toggle]');
      var list = group.querySelector('.tcg-hub-catalogue__list');
      var icon = group.querySelector('.tcg-hub-catalogue__group-icon');
      openCategories[category] = open;
      group.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (list) list.hidden = !open;
      if (icon) icon.textContent = open ? '-' : '+';
      syncBulkButtons();
    }

    function syncGroupOpenStates() {
      root.querySelectorAll('[data-tcg-catalogue-group]').forEach(function (group) {
        setGroupOpen(group, !!openCategories[group.dataset.category]);
      });
      syncBulkButtons();
    }

    function visibleGroups() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-tcg-catalogue-group]')).filter(function (group) {
        return !group.hidden;
      });
    }

    function syncBulkButtons() {
      if (!expand || !collapse) return;
      var visible = visibleGroups();
      var openVisible = visible.filter(function (group) {
        return !!openCategories[group.dataset.category];
      });
      expand.disabled = visible.length > 0 && openVisible.length === visible.length;
      collapse.disabled = openVisible.length === 0;
    }

    function applyFilters() {
      var query = search.value.trim().toLowerCase();
      var visibleCount = 0;
      var groupNodes = root.querySelectorAll('[data-tcg-catalogue-group]');
      var itemNodes = root.querySelectorAll('[data-tcg-catalogue-item]');

      itemNodes.forEach(function (item) {
        var categoryMatches = activeCategory === 'all' || item.dataset.category === activeCategory;
        var searchMatches = !query || (item.dataset.search || '').indexOf(query) !== -1;
        var visible = categoryMatches && searchMatches;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      groupNodes.forEach(function (group) {
        var anyVisible = !!group.querySelector('[data-tcg-catalogue-item]:not([hidden])');
        var categoryVisible = activeCategory === 'all' || group.dataset.category === activeCategory;
        group.hidden = !(anyVisible && categoryVisible);
      });

      count.textContent = visibleCount + (visibleCount === 1 ? ' product' : ' products');
      clear.hidden = search.value.trim() === '';
      empty.hidden = visibleCount !== 0;
      syncGroupOpenStates();
    }

    function openVisibleGroups() {
      root.querySelectorAll('[data-tcg-catalogue-group]').forEach(function (group) {
        var hasVisibleProducts = !!group.querySelector('[data-tcg-catalogue-item]:not([hidden])');
        openCategories[group.dataset.category] = !group.hidden && hasVisibleProducts;
      });
      syncGroupOpenStates();
    }

    function setVisibleGroupsOpen(open) {
      visibleGroups().forEach(function (group) {
        openCategories[group.dataset.category] = open;
      });
      syncGroupOpenStates();
    }

    function openDefaultGroup() {
      Object.keys(openCategories).forEach(function (category) {
        openCategories[category] = category === defaultOpenCategory;
      });
      syncGroupOpenStates();
    }

    filters.querySelectorAll('button[data-category]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeCategory = button.dataset.category || 'all';
        filters.querySelectorAll('button[data-category]').forEach(function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        applyFilters();
        if (activeCategory === 'all' && search.value.trim() === '') {
          openDefaultGroup();
        } else {
          openVisibleGroups();
        }
      });
    });

    filters.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (!target || !target.matches || !target.matches('button[data-category]')) return;
      event.preventDefault();
      activeCategory = target.dataset.category || 'all';
      filters.querySelectorAll('button[data-category]').forEach(function (candidate) {
        var selected = candidate === target;
        candidate.classList.toggle('is-active', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      applyFilters();
      if (activeCategory === 'all' && search.value.trim() === '') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
    });

    root.querySelectorAll('[data-tcg-catalogue-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var group = toggle.closest('[data-tcg-catalogue-group]');
        if (!group) return;
        setGroupOpen(group, !openCategories[group.dataset.category]);
      });
    });

    if (expand) {
      expand.addEventListener('click', function () {
        setVisibleGroupsOpen(true);
      });
    }

    if (collapse) {
      collapse.addEventListener('click', function () {
        setVisibleGroupsOpen(false);
      });
    }

    bindAddButtons(root);
    bindGlobalChooserEvents();

    search.addEventListener('input', function () {
      applyFilters();
      if (search.value.trim() === '' && activeCategory === 'all') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
    });
    clear.addEventListener('click', function () {
      search.value = '';
      applyFilters();
      if (activeCategory === 'all') {
        openDefaultGroup();
      } else {
        openVisibleGroups();
      }
      search.focus();
    });
    applyFilters();
  }

  function init() {
    var data = window.tcgPartsCatalogueData;
    document.querySelectorAll('[data-tcg-featured-parts]').forEach(function (root) {
      bindAddButtons(root);
      initFeaturedCarousel(root);
    });

    document.querySelectorAll('[data-tcg-catalogue]').forEach(function (root) {
      if (!data || !Array.isArray(data.products)) {
        var empty = root.querySelector('[data-tcg-catalogue-empty]');
        if (empty) {
          empty.hidden = false;
          empty.textContent = 'Parts catalogue data is not available in this preview.';
        }
        return;
      }
      render(root, data);
    });

    bindGlobalChooserEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
